import { memo } from 'react';
import { lineHeightStyle, styledComponent } from '../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';
import { EYE_EXAM_ITEMS } from '../eyeExamination';

const EyeExaminationView = ({
  selectedOnExamination,
  setSelectedOnExamination,
  prescriptionItems,
  isHistoryPage,
}) => {
  const eyeExamination = selectedOnExamination?.eyeExamination;
  if (!eyeExamination) return null;

  const hasAnyData = EYE_EXAM_ITEMS.some(
    ({ key }) => eyeExamination[key]?.right || eyeExamination[key]?.left,
  );
  if (!hasAnyData) return null;

  const Title = styledComponent(
    prescriptionItems?.items?.['on-examination']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
  );

  const clearRow = (key) => {
    const updated = { ...eyeExamination, [key]: { right: '', left: '' } };
    setSelectedOnExamination({ ...selectedOnExamination, eyeExamination: updated });
  };

  return (
    <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
      {EYE_EXAM_ITEMS.map(({ key, label }) => {
        const right = eyeExamination[key]?.right;
        const left = eyeExamination[key]?.left;
        if (!right && !left) return null;
        return (
          <li key={key} className="text-left" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>
              <Title>{label}:</Title>{' '}
              {right && <Value>RE: {right}</Value>}
              {right && left && <span>, </span>}
              {left && <Value>LE: {left}</Value>}
            </span>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn action={clearRow} itemName={key} />
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default memo(EyeExaminationView);
